<template>
  <span v-if="!isBlocked && !hasIncident" class="mail-status" :class="'-' + statusColor">
    <FontAwesomeIcon class="mail-status__icon" :icon="'fa-light fa-' + statusIcon" aria-hidden="true" />
    <span class="mail-status__label">{{ statusLabel }}</span>
  </span>
  <button
    v-else
    type="button"
    class="mail-status -link"
    :class="'-' + statusColor"
    v-tooltip="{ title: statusLabel }"
    @click="$emit('open')"
  >
    <FontAwesomeIcon class="mail-status__icon" :icon="'fa-light fa-' + statusIcon" aria-hidden="true" />
    <span class="visually-hidden">{{ statusLabel }} : </span>
    <span class="mail-status__link">{{ $t(isBlocked ? "mail_status.see_message" : "mail_status.see_incident") }}</span>
  </button>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { mailStatusManager } from "@/services/mail-status/mail-status-manager";

export default {
  name: "MailStatusChipComponent",
  components: { FontAwesomeIcon },
  props: {
    mailStatus: {
      type: Object,
      required: true,
    },
  },
  emits: ["open"],
  computed: {
    status() {
      return this.mailStatus?.status ?? null;
    },
    isBlocked() {
      return mailStatusManager.isBlocked(this.status);
    },
    hasIncident() {
      return mailStatusManager.hasIncident(this.mailStatus);
    },
    statusColor() {
      return mailStatusManager.getStatusColor(this.status, this.hasIncident);
    },
    statusIcon() {
      return mailStatusManager.getStatusIcon(this.status, this.hasIncident);
    },
    statusLabel() {
      return this.$t(mailStatusManager.getStatusLabelKey(this.status, this.hasIncident));
    },
  },
};
</script>

<style lang="scss" scoped>
.mail-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  padding: 0;
  border: none;
  background: none;
  text-align: left;

  &__icon {
    flex-shrink: 0;
  }

  &__link {
    text-decoration: underline;
  }

  &.-link {
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid currentColor;
      outline-offset: 2px;
      border-radius: 4px;
    }
  }

  &.-success {
    color: $d-success;

    @include dark-theme {
      color: $l-success;
    }
  }

  &.-warning {
    color: $d-warning;

    @include dark-theme {
      color: $l-warning;
    }
  }

  &.-danger {
    color: $d-danger;

    @include dark-theme {
      color: $l-danger;
    }
  }
}
</style>
